import FinishStep from './FinishStep';
import UploadStep from './UploadStep';
import ValidationStep from './ValidationStep';

export default {
  title: 'Seuraajat',
  steps: {
    upload: 'Lataa',
    validate: 'Vahvista',
    finish: 'Valmis',
  },
  labels: {
    import: 'Tuonti',
  },

  FinishStep,
  UploadStep,
  ValidationStep,
};
